module.exports = __webpack_public_path__ + "static/media/upcomingEvents_2.68cac1e5.jpg";